import React from "react";
import toast from "react-hot-toast";
import { replaceString } from "./../../utils/helpers/dataHelper";
import { DocumentCardContainer } from "./style";

const DocumentCard = ({ name, link, history, requiredDocuments, type }) => {
  const handleClick = (link) => {
    link = `/dashboard${type}${link}`;
    if (name === "Document Tracking") {
      history.push(link);
    } else {
      if (requiredDocuments.length > 0) {
        const list = requiredDocuments.map((d) =>
          replaceString(d.toLowerCase())
        );
        history.push(`/dashboard${type}profile`);
        toast.error("Upload " + list + " to continue your document processing");
      } else {
        history.push(link);
      }
    }
  };

  return (
    <DocumentCardContainer
      onClick={() => handleClick(link)}
    >
      <div className="mt-2 font-bold text-center py-8 text-lg">{name}</div>
    </DocumentCardContainer>
  );
};

export default DocumentCard;
